/**
 * Week calculation utilities
 */

/**
 * Calculates the week string for a given date
 * @param {Date} date - Date to calculate week for
 * @returns {string} Week string in format "YYYY-WXX"
 */
export function calculateWeek(date) {
  const year = date.getUTCFullYear();
  const dayOfYear = Math.ceil((date.getTime() - new Date(year, 0, 1).getTime()) / (1000 * 60 * 60 * 24));
  const weekNumber = Math.ceil(dayOfYear / 7);
  return `${year}-W${weekNumber}`;
}

/**
 * Adds week field to an item based on its closed date
 * @param {Object} item - Item with closedDate
 * @returns {Object} Item with week field added
 */
export function addWeekField(item) {
  return {
    ...item,
    week: calculateWeek(item.closedDate)
  };
}
